import { productsNav } from 'Bomdisoft/shared/products/nav-manifest';
import { delegateDocsContent, delegateDocsShell } from '@bomdisoft/components/native';

/** The products index and every product page share one docs shell; this attaches its navigation, drawer and contents behaviour. */
export const delegateProductsPage = (view: Window, lang: string) => {
  const shell = view.document.querySelector<HTMLElement>('[data-testid="products-shell"], [data-testid^="product-shell-"]');
  if (shell === null) return () => {};
  const releases = [delegateDocsShell(shell, { langPrefix: lang, nav: productsNav, onNavigate: href => view.location.assign(href), pathname: view.location.pathname }), delegateDocsContent(shell)];
  return () => {
    for (const release of releases) release();
  };
};
